/* Modern Roots — float guard (9-28-26, CHECKOUT CLEAR).
   Keeps the floating "Sales & Discount Codes" tab (#sas-tab) and the Missive chat button off the buttons that matter:
   - any drawer open (cart, offers) or the mobile menu open: both step aside, so Checkout is never covered
   - a sticky buy bar showing at the bottom (mobile Add to cart, Salt of Life bar): the tab rides above it, the chat button steps aside until the bar goes away
   Missive is driven only through its official JS API (hideButton / showButton). Nothing else on the page is touched. */
(function(){
  var d=document, html=d.documentElement;
  var BARS='[data-mrl-satc], .sol-stickybar';
  var missiveHidden=false;
  function missive(){ var m=window.MissiveChat; return (window.__mrlMissiveReady && m && typeof m.hideButton==='function' && typeof m.showButton==='function') ? m : null; }
  function overlayOpen(){ return !!((d.body && d.body.classList.contains('js-drawer-open')) || html.classList.contains('mrlnav-lock')); }
  function barLift(){
    var els=d.querySelectorAll(BARS), vh=window.innerHeight||html.clientHeight, top=vh, i, el, cs, r;
    for(i=0;i<els.length;i++){
      el=els[i]; if(!el.getClientRects().length) continue;
      cs=window.getComputedStyle(el);
      if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)===0) continue;
      r=el.getBoundingClientRect(); if(r.height<1) continue;
      if(r.top<vh-2 && r.bottom>vh-6 && r.top<top) top=r.top;
    }
    return Math.max(0, Math.round(vh-top));
  }
  function apply(){
    var over=overlayOpen(), lift=over?0:barLift();
    html.classList.toggle('mrl-float-off', over);
    html.classList.toggle('mrl-float-lift', lift>0);
    if(lift>0){ html.style.setProperty('--mrl-float-lift', lift+'px'); }
    var hide=over||lift>0, m=missive();
    if(m && hide!==missiveHidden){ try{ if(hide){ m.hideButton(); } else { m.showButton(); } missiveHidden=hide; }catch(e){} }
  }
  var t=null; function soon(){ if(t===null){ t=setTimeout(function(){ t=null; apply(); },80); } }
  window.addEventListener('scroll',soon,{passive:true});
  window.addEventListener('resize',soon);
  window.addEventListener('mrl:missive-ready',function(){ missiveHidden=false; apply(); });
  function start(){
    if(window.MutationObserver){
      var mo=new MutationObserver(soon);
      try{ mo.observe(html,{attributes:true,attributeFilter:['class']}); if(d.body){ mo.observe(d.body,{attributes:true,attributeFilter:['class']}); } }catch(e){}
    }
    apply(); setTimeout(apply,1500);
  }
  if(d.readyState==='loading'){ d.addEventListener('DOMContentLoaded',start); } else { start(); }
})();
